import React, { Component, Fragment } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Link } from '@reach/router';
import { Search } from '@material-ui/icons';
import Sidebar from './Sidebar/Sidebar';
import Topbar from './Topbar/Topbar';
import Main from './Main/Main';
import Input, { INPUT_TYPES } from './Input/Input';
import {
  COUNTRY_MARKET_GROUP,
  SALESCHANNEL_NAME_MAP,
  LOCALE_NAME_MAP,
} from './../constants';
import { withGlobalContext } from '../App';
import { ChannelingToggleSwitcher } from './Channeling/ChannelingToggleSwitcher';

class MarketGroup extends Component {
  constructor(props) {
    super(props);

    this.state = {
      searchQuery: '',
      list: COUNTRY_MARKET_GROUP,
      toggles: []
    };
  }

  onChange = event => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  };

  getFilteredList = () => {
    let { searchQuery } = this.state;
    searchQuery = searchQuery.toLowerCase().trim();

    if (!searchQuery) {
      return this.state.list;
    }

    return this.state.list.reduce((filteredList, countryGroup) => {
      // if search query matches the country group then
      // all the markets inside should be returned
      const { country: salesChannel } = countryGroup;
      const country = SALESCHANNEL_NAME_MAP[salesChannel].toLowerCase();

      if (country.includes(searchQuery)) {
        filteredList.push(countryGroup);
      } else {
        const filteredMarkets = countryGroup.languages.filter(locale => {
          const language = LOCALE_NAME_MAP[locale].toLowerCase();
          return language.includes(searchQuery);
        });

        if (filteredMarkets.length) {
          filteredList.push({
            country: salesChannel,
            languages: filteredMarkets,
          });
        }
      }
      return filteredList;
    }, []);
  };

  render() {
    return (
      <Fragment>
        <Sidebar highlightNavItemIndex={this.props.highlightNavItemIndex} />
        <Topbar className="flex justify-between items-center">
          <span className="font-bold text-lg capitalize">{this.props.title}</span>
          {
            this.props.title === 'Channeling' &&
            <ChannelingToggleSwitcher />
          }
          <Input
            className="topbar__search w-64"
            id="searchQuery"
            name="searchQuery"
            type={INPUT_TYPES.TEXT}
            value={this.state.searchQuery}
            onChange={this.onChange}
            inputClassName="shadow-inner bg-almostWhite rounded-full pl-10"
            inputWrapperClassName="rounded-full relative"
            foreignComponent={
              <Search className="absolute text-darkGrey" fontSize="small" />
            }
          />
        </Topbar>
        <Main>
          <ul className="list-reset">
            <AnimatePresence initial={false}>
              {this.getFilteredList().map(countryGroup => {
                const { country, languages } = countryGroup;
                return (
                  <li className="mb-8" key={country}>
                    <div className="uppercase font-bold text-darkGrey tracking-wide mb-2">
                      {SALESCHANNEL_NAME_MAP[country]}
                    </div>
                    <ul className="list-reset">
                      {languages.map(language => (
                        <motion.li
                          initial={{ opacity: 0, y: '-100%' }}
                          animate={{ opacity: 1, y: '0%' }}
                          exit={{ opacity: 0, y: '-100%' }}
                          transition={{ ease: 'circOut', duration: 0.3 }}
                          positionTransition
                          className="mb-2"
                          key={`${country}_${language}`}>
                          <Link
                            to={`${country}/${language}`}
                            onClick={() =>
                              this.props.updateMarket({
                                savedLanguage: language,
                                savedCountry: country,
                              })
                            }
                            className="market_link block no-underline bg-white px-8 py-3 capitalize hover:shadow-md">
                            {LOCALE_NAME_MAP[language]}
                          </Link>
                        </motion.li>
                      ))}
                    </ul>
                  </li>
                );
              })}
            </AnimatePresence>
          </ul>
        </Main>
      </Fragment>
    );
  }
}

export default  withGlobalContext(MarketGroup);
